export const styles = {
    container: {
        w: "100%",
    },
    header: {},
    accordionButton: {
        justifyContent: "flex-start",
        p: 0,
        _expanded: {
            p: 0,
        },
        _hover: {
            bg: "none",
        },
    },
    accordionPanel: {
        px: 0,
        pt: 2,
        pb: 0,
    },
    input: {
        flexDirection: "column",
        w: "100%",
        "& input": {
            h: [9.6, 10.4],
            transform: "none",
        },
    },
    applyButton: {
        w: "auto",
        minW: "16",
        h: [9.6, 10.4],
        lineHeight: 1.7,
        bg: "gray.800",
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
        fontWeight: "bold",
    },
    text: {
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
        fontWeight: "bold",
    },
};
